import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M4.3,6.41H6.5L7,8.08H8.16l-2-6.36H4.66l-2,6.36H3.82ZM5.38,2.49l.84,3H4.55Zm4.72,5.2a1.71,1.71,0,0,0,1.26.52,1.7,1.7,0,0,0,1-.29,2.14,2.14,0,0,0,.73-.82A2.59,2.59,0,0,0,13.33,6V5.9a3,3,0,0,0-.22-1.21,2,2,0,0,0-.64-.8,1.77,1.77,0,0,0-1-.28,1.64,1.64,0,0,0-1.25.5V1.72H9.12V8.1H10ZM10.25,5a1.33,1.33,0,0,1,.44-.38,1.29,1.29,0,0,1,.58-.13c.63,0,.94.46.94,1.39V6a1.77,1.77,0,0,1-.28,1,.89.89,0,0,1-.76.4,1.19,1.19,0,0,1-.92-.4ZM13.8,12.7l-2.13,2.13a.77.77,0,0,1-.53.22.75.75,0,0,1-.29-.06.74.74,0,0,1-.46-.69V12.92H2.67a.75.75,0,0,1,0-1.5h7.72V10a.75.75,0,0,1,1.28-.53l2.13,2.13A.75.75,0,0,1,13.8,12.7Z';
const draw24px =
  'M9.74,9.61H6.45l-.72,2.51H4L6.91,2.58H9.24l3.06,9.54H10.53ZM6.83,8.23H9.34L8.07,3.78ZM18.7,5.84a2.76,2.76,0,0,1,1,1.2A4.43,4.43,0,0,1,20,8.85V9a3.73,3.73,0,0,1-.36,1.65,3.12,3.12,0,0,1-1.1,1.23,2.72,2.72,0,0,1-1.5.44,2.51,2.51,0,0,1-1.89-.79l-.15.62H13.68V2.58h1.69V6.17a2.49,2.49,0,0,1,1.88-.75A2.52,2.52,0,0,1,18.7,5.84Zm-.39,3c0-1.4-.47-2.1-1.4-2.1a1.92,1.92,0,0,0-.87.2,1.87,1.87,0,0,0-.67.58v2.95a1.84,1.84,0,0,0,1.39.6,1.36,1.36,0,0,0,1.14-.56,2.6,2.6,0,0,0,.41-1.57Zm2.13,8.93-3.19-3.19a.75.75,0,0,0-1.28.53v2.44H4A.75.75,0,0,0,4,19H16v2.44a.75.75,0,0,0,.46.69.72.72,0,0,0,.29.06.77.77,0,0,0,.53-.22l3.19-3.19a.75.75,0,0,0,0-1.06Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextOrientationHorizontalRightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(
  generateRenderedIcon(icons, 'textOrientationHorizontalRight'),
) as IconWithRender;

TextOrientationHorizontalRightIcon.displayName =
  'TextOrientationHorizontalRightIcon';
TextOrientationHorizontalRightIcon.propTypes = Icon.propTypes;
TextOrientationHorizontalRightIcon.renderIcon = (props) => (
  <TextOrientationHorizontalRightIcon {...props} />
);
export default TextOrientationHorizontalRightIcon;
